module.exports = __webpack_public_path__ + "img/LogoTpApoSmall.5600b10c.png";